export default {
  office: {
    breadcrumbHome: 'Accueil',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Bureau et cabinet',
    hero: {
      eyebrow: 'Bureau et cabinet',
      title: 'Une surveillance discrète pour les environnements de travail',
      lead: 'Accueil, couloirs, zones sensibles : nous planifions des systèmes de caméras qui protègent sans inquiéter employés ni patients.',
    },
    areas: {
      title: "Zones d'utilisation dans les bureaux et cabinets",
      lead: 'Les bureaux et cabinets modernes ont besoin d’une sécurité discrète. Nous intégrons les caméras subtilement dans l’architecture.',
      items: {
        '0': { title: 'Accueil', desc: 'La première impression et le premier point de surveillance. Les caméras d’accueil documentent les visiteurs et sécurisent l’accès.' },
        '1': { title: 'Couloirs', desc: 'Les longs couloirs sont souvent des angles morts. Des caméras de plafond compactes comblent les lacunes discrètement.' },
        '2': { title: 'Salles de réunion', desc: 'Toutes les réunions ne doivent pas être enregistrées. Nous configurons les caméras pour ne capter que les zones pertinentes.' },
        '3': { title: 'Salle serveur', desc: 'La pièce où se trouvent vos données mérite une attention particulière. Accès et activité sont journalisés.' },
        '4': { title: 'Accueil de cabinet', desc: 'La discrétion compte dans les cabinets. Nous montons des caméras sobres qui protègent sans inquiéter les patients.' },
        '5': { title: 'Parking et entrée', desc: 'Les parkings et entrées extérieurs sont particulièrement exposés la nuit. Des caméras résistantes avec vision nocturne veillent.' },
      },
    },
    access: {
      eyebrow: 'Accès et contrôle',
      title: 'Qui peut voir quoi ?',
      lead: "Un système de caméras au bureau n'est accepté que si les droits sont clairs. Nous configurons des droits différenciés et documentons chaque usage.",
      items: {
        '0': { title: 'Gestion des utilisateurs', desc: 'Chaque personne reçoit exactement les droits nécessaires, de la vue en direct à la lecture.' },
        '1': { title: 'Masquage des zones privées', desc: 'Les zones comme les salles de pause ou vestiaires sont masquées techniquement, dans la caméra ou l’enregistreur.' },
        '2': { title: 'Journal des événements', desc: 'Qui a vu quoi et quand ? Un journal d’accès complet permet un contrôle traçable.' },
      },
    },
    privacy: {
      eyebrow: 'Protection des données',
      title: 'Protection des données au travail',
      lead: 'Employés et visiteurs bénéficient d’une protection spéciale. Nous mettons en œuvre votre surveillance de façon conforme et juste, et vous conseillons sur la documentation de la nécessité.',
      list: {
        '0': 'Enregistrer uniquement là où c’est opérationnellement nécessaire',
        '1': 'Signalétique pour employés et visiteurs',
        '2': 'Aucune surveillance des vestiaires, toilettes ou salles de pause',
        '3': 'Accès aux enregistrements réservé aux personnes autorisées',
        '4': 'Documentation de la nécessité opérationnelle',
      },
      note: 'Remarque : la surveillance des lieux de travail est soumise à des exigences légales strictes. Nous vous conseillons techniquement, sans remplacer le conseil juridique.',
    },
    cta: {
      title: 'Discret. Respectueux de la vie privée. Fiable.',
      lead: 'Nous planifions votre système de bureau ou cabinet pour qu’il protège sans déranger au quotidien. Sans engagement et en toute transparence.',
      primary: 'Prendre rendez-vous',
      secondary: 'Lancer le planificateur de caméras',
    },
  },
};